/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressTypeFromJSON, AddressTypeToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, CollectorAdministratorFromJSON, CollectorAdministratorToJSON, CustomerFromJSON, CustomerToJSON, } from './';
export function AddressFromJSON(json) {
    return AddressFromJSONTyped(json, false);
}
export function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'customer': !exists(json, 'customer') ? undefined : CustomerFromJSON(json['customer']),
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'collectorAdministratorId': !exists(json, 'collectorAdministratorId') ? undefined : json['collectorAdministratorId'],
        'collectorAdministrator': !exists(json, 'collectorAdministrator') ? undefined : CollectorAdministratorFromJSON(json['collectorAdministrator']),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'city': json['city'],
        'street': json['street'],
        'buildingNumber': json['buildingNumber'],
        'apartmentNumber': !exists(json, 'apartmentNumber') ? undefined : json['apartmentNumber'],
        'postalCode': json['postalCode'],
        'additionalInfo': !exists(json, 'additionalInfo') ? undefined : json['additionalInfo'],
        'type': !exists(json, 'type') ? undefined : AddressTypeFromJSON(json['type']),
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
    };
}
export function AddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'customer': CustomerToJSON(value.customer),
        'customerId': value.customerId,
        'collectorAdministratorId': value.collectorAdministratorId,
        'collectorAdministrator': CollectorAdministratorToJSON(value.collectorAdministrator),
        'country': value.country,
        'city': value.city,
        'street': value.street,
        'buildingNumber': value.buildingNumber,
        'apartmentNumber': value.apartmentNumber,
        'postalCode': value.postalCode,
        'additionalInfo': value.additionalInfo,
        'type': AddressTypeToJSON(value.type),
        'isDefault': value.isDefault,
        'isDeleted': value.isDeleted,
    };
}
